export default "__VITE_ASSET__BbSq07wj__"